import { useIntl } from 'react-intl';
import AlertDialog from '@alltrails/denali/components/AlertDialog';

type HidePOIConfirmationProps = {
  onHide: (e?: React.MouseEvent<HTMLElement>) => void;
  setShowHideConfirmation: (show: boolean) => void;
  isHiding: boolean;
  popupCardType: 'poi' | 'photospot';
};

const HidePOIConfirmation = ({ onHide, setShowHideConfirmation, isHiding, popupCardType }: HidePOIConfirmationProps) => {
  const intl = useIntl();
  const type = popupCardType === 'poi' ? 'POI' : 'photospot';
  return (
    <AlertDialog
      title={intl.formatMessage({ defaultMessage: 'Hide {type}?' }, { type })}
      body={intl.formatMessage({ defaultMessage: 'Are you sure you want to hide this {type}?' }, { type })}
      buttons={{
        primary: {
          onClick: e => onHide(e),
          text: intl.formatMessage({ defaultMessage: 'Hide' }),
          testId: 'poi-hide-button',
          loading: isHiding
        },
        flat: {
          onClick: () => setShowHideConfirmation(false),
          text: intl.formatMessage({ defaultMessage: 'Cancel' }),
          testId: 'poi-cancel-hide-button'
        }
      }}
      onRequestClose={() => setShowHideConfirmation(false)}
      size="sm"
    />
  );
};

export default HidePOIConfirmation;
